import Icon from 'veui/components/Icon'
import { IconBookmark } from 'dls-icons-vue'

Icon.register('bookmark', IconBookmark)
